export default __webpack_public_path__ + "static/media/Autoinduction.727f721c.pdf";